export function sanitise(url: string): string {
    return url.endsWith("/") ? url.substring(0, url.length - 1) : url;
  }
  